export default __webpack_public_path__ + "images/c4a5fa161a6869266fa3a31e441ad65b.svg";